import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SendEmailForm from './SendEmailForm';


class EmailDialog extends PureComponent {
    render() {
        const {
            open,
            cancel,
            title,
            templateEditor,
            templatesFieldName = 'notesEmailTemplates',
            enableAddTemplate = true,
            enableEditTemplate = true,
        } = this.props;

        return (
            <SendEmailForm templatesFieldName={templatesFieldName}
                           renderTemplateLoad={templateEditor}
                           renderEmailSection
                           renderEmailButton={!templateEditor}
                           disableCaseFilesAutoload={this.props.disableCaseFilesAutoload}
                           onEmailSent={this.props.cancel}
                           initialTemplate={this.props.initialTemplate}
                           initialEmail={this.props.initialEmail}
                           enableAddTemplate={enableAddTemplate}
                           enableEditTemplate={enableEditTemplate}
                           showAsDialog
                           open={open}
                           cancel={cancel}
                           title={title}
            />
        );
    }
}

EmailDialog.propTypes = {
    title: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    cancel: PropTypes.func.isRequired,
    templateEditor: PropTypes.bool,
    disableCaseFilesAutoload: PropTypes.bool,
};


export default EmailDialog;